import _ from 'lodash'
import React, { useMemo, useCallback } from 'react'
import { InputBase, Paper, Grid, Button, IconButton } from '@material-ui/core'
import { Clear, Search } from '@material-ui/icons'
import cn from 'classnames'

import UsersList from '../UsersList'
import useStyles from './useStyles'
import useDebounce from 'utils/useDebounce'

function UserSearch({ timesheetMode, query, selected, onChange, onSearch, onSelect, onSubmit }) {
  const classes = useStyles()

  // Debounce search query to avoid searching on every keystroke
  const debouncedQuery = useDebounce(query, 300)

  // Memoize filtered users to prevent unnecessary recalculations
  const filteredUsers = useMemo(() => onSearch(debouncedQuery), [debouncedQuery, onSearch])

  const handleInputChange = useCallback(e => onChange(e.target.value), [onChange])

  const handleCheckIn = useCallback(() => {
    onSubmit(selected)
  }, [onSubmit, selected])

  const handleClear = useCallback(() => onChange(''), [onChange])

  return (
    <>
      <Grid Container>
        <Grid item>
          <Paper className={classes.root}>
            <IconButton className={classes.iconButton} aria-label="Search" disableRipple={true}>
              <Search />
            </IconButton>
            <InputBase
              className={classes.input}
              onChange={handleInputChange}
              value={query}
              placeholder="User Name or phone number"
              inputProps={{ 'aria-label': 'User Name or phone number' }}
              autoFocus
            />
            {!_.isEmpty(query) && (
              <IconButton className={classes.iconButton} aria-label="Search" onClick={handleClear} disableRipple={true}>
                <Clear />
              </IconButton>
            )}
          </Paper>
          <Grid container direction="column">
            <UsersList users={filteredUsers} onSelect={onSelect} selected={selected} timesheetMode={timesheetMode} />
            <Grid item className={classes.checkInWrapper}>
              <Button
                variant="contained"
                color="secondary"
                disabled={!(selected || {}).id}
                disableRipple={true}
                className={cn(
                  classes.checkIn,
                  timesheetMode === 'check-in' ? classes.checkInColor : classes.checkOutColor,
                )}
                onClick={handleCheckIn}
              >
                {timesheetMode === 'check-in' ? 'Check in' : 'Check out'}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

// Memoize to prevent re-renders when props don't change
export default React.memo(UserSearch)
